export function getMyLoginFromIdentityToken(
  identityToken: string,
  decoder: AuthTokenDecoder
): string | null {
  return decoder.extractEmail(identityToken);
}

export type Email = string | null;

export interface AuthTokenDecoder {
  extractEmail(token: string): Email;
}
